import {
  Container,
  HeadingText,
  small,
} from '@unmind/design-system-components-web';
import { ThemeInterface } from 'styles/lightTheme';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export const ManagersWrapper = styled(Container)`
  padding-bottom: 100px;
  padding-top: 80px;

  ${small(css`
    padding-bottom: 26px;
  `)}
`;

export const ManagersScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  padding-top: 0;
`;

export const ErrorWrapper = styled.div`
  margin-top: 56px;
`;

const SectionHeadingTitleAttrs = ({ theme }: { theme: ThemeInterface }) => ({
  level: 3,
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize20],
  weight: theme.typography.fontWeights.semiBold,
});

export const SectionHeadingTitleStyle = css`
  &:focus {
    outline: none;
  }

  ${small(css`
    line-height: 1.3;
  `)}
`;

export const SectionHeadingTitle = styled(HeadingText).attrs(
  SectionHeadingTitleAttrs,
)`
  ${SectionHeadingTitleStyle}
  margin-bottom: ${rem(20)};
`;
